import { describeApiError } from "@/shared/api/error-message";

export async function getMutationErrorMessage(error: unknown): Promise<string> {
	return describeApiError(error);
}
